import PropTypes from 'prop-types';
import { useMemo, useState, useEffect } from 'react';

import DiagnosticFormContext from './diagnostic-context';

const LOCAL_STORAGE_KEY = 'unsavedDiagnosticForms';

export const DiagnosticFormProvider = ({ children }) => {
  const [diagnosticForms, setDiagnosticForms] = useState([]);

  useEffect(() => {
    const stored = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        setDiagnosticForms(parsed);
      } catch (e) {
        console.error('Error parsing localStorage data:', e);
      }
    }
  }, []);

  useEffect(() => {
    const currentStored = localStorage.getItem(LOCAL_STORAGE_KEY);
    const currentData = JSON.stringify(diagnosticForms);

    if (currentStored !== currentData) {
      localStorage.setItem(LOCAL_STORAGE_KEY, currentData);
    }
  }, [diagnosticForms]);

  const updateForm = (admissionId, formData) => {
    setDiagnosticForms((prev) => {
      const existingIndex = prev.findIndex((f) => f.AdmissionID === admissionId);
      if (existingIndex !== -1) {
        const updated = [...prev];
        updated[existingIndex] = { ...updated[existingIndex], ...formData };
        return updated;
      }
      return [...prev, { AdmissionID: admissionId, ...formData }];
    });
  };

  const getForm = (admissionId) => {
    const stored = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (stored) {
      const forms = JSON.parse(stored);
      return forms.find((f) => f.AdmissionID === admissionId);
    }
    return null;
  };

  const removeForm = (admissionId) => {
    const updatedForms = diagnosticForms.filter((f) => f.AdmissionID !== admissionId);
    setDiagnosticForms(updatedForms);
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(updatedForms));
  };

  const contextValue = useMemo(
    () => ({
      diagnosticForms,
      updateForm,
      getForm,
      removeForm,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [diagnosticForms]
  );

  return (
    <DiagnosticFormContext.Provider value={contextValue}>{children}</DiagnosticFormContext.Provider>
  );
};

DiagnosticFormProvider.propTypes = {
  children: PropTypes.node,
};
